import { useTranslation } from 'react-i18next';
import { Loader2, Trash2 } from 'lucide-react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';

export const DeleteLawsuitDialog = ({ lawsuit, deleting, error, onClose, onConfirm }) => {
  const { t } = useTranslation();
  return <AlertDialog open={Boolean(lawsuit)} onOpenChange={open => { if (!open && !deleting) onClose(); }}>
    <AlertDialogContent data-testid="lawsuit-delete-dialog" data-pending={deleting ? 'true' : 'false'} aria-busy={deleting} className="w-[calc(100%_-_2rem)] max-h-[90vh] overflow-y-auto">
      <AlertDialogHeader>
        <AlertDialogTitle data-testid="lawsuit-delete-title">{t('lawsuitDeletion.title')}</AlertDialogTitle>
        <AlertDialogDescription data-testid="lawsuit-delete-warning">{t('lawsuitDeletion.warning', { count: lawsuit?.court_dates?.length || 0 })}</AlertDialogDescription>
      </AlertDialogHeader>
      <div className="border-l-2 border-red-300 pl-3 min-w-0 text-sm">
        <p data-testid="lawsuit-delete-case-number" className="text-slate-500 break-words">{lawsuit?.case_number}</p>
        <p data-testid="lawsuit-delete-case-name" className="font-medium break-words">{lawsuit?.title}</p>
      </div>
      {error && <p role="alert" className="text-sm text-red-700" data-testid="lawsuit-delete-error">{error}</p>}
      <AlertDialogFooter>
        <AlertDialogCancel disabled={deleting} data-testid="lawsuit-delete-cancel">{t('common.cancel')}</AlertDialogCancel>
        <AlertDialogAction disabled={deleting} data-testid="lawsuit-delete-confirm" className="bg-red-600 hover:bg-red-700 text-white whitespace-normal h-auto min-h-10"
          onClick={event => { event.preventDefault(); onConfirm(); }}>
          {deleting ? <Loader2 className="mr-2 w-4 h-4 shrink-0 animate-spin" /> : <Trash2 className="mr-2 w-4 h-4 shrink-0" />}
          {t(deleting ? 'lawsuitDeletion.deleting' : 'lawsuitDeletion.action')}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
};